import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './CaseInvoice.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Drawer, TableFooter, TablePagination, Link, Breadcrumbs, Typography } from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from './components/SideList'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import { roleStr, roleName, defaultPageSize, ADD, EDIT, VIEW } from '../../common/common';
import { timeFormat } from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';

const ADMIN = "admin";
class CaseInvoice extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            totalUser: [],
            client_id: 0,
            showAlert: false,
            caseNumber: "",
            case_id: "",

            client_name: "",
            case_number: "",
            matter_number: "",
            start_date: "",
            end_date: "",
            status: "",
            handler_id: 0,
            handler_office: "",
            handler_team_id: 0,
            handler_department_id: 0,
            invoiceData: [],

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreateInvoice = this.handleCreateInvoice.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
        this.handleSendEmail = this.handleSendEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            caseNumber,
            invoiceData,
            showAlert,
            showToast,
            toastMsg,
            toastState,
            page_index,
            page_size,
            total_items,
        } = this.state;
        const delBtnView = (row) => {
            if (roleName === ADMIN) {
                return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
            }
        }
        const editBtnView = (row) => {
            if (row.status !== "complete") {
                return <Button size="small" variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/case">All Cases</Link>
                            <Typography className="crtTitle">{caseNumber} Invoice</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="tableTool h">
                    <Button className="bgW btn" variant="contained" onClick={e => this.handleDrawer(e, true)}> Show Filters </Button>
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search invoice by client name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'client_name')}
                        />
                    </div>
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search invoice by Invoice #"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'invoice')}
                        />
                    </div>
                    <div className="searchWapper wLong h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search invoice by case number / matter number"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'number')}
                        />
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Invoice #</TableCell>
                                <TableCell>Matter #</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Originating Attorney</TableCell>
                                <TableCell>Total Due</TableCell>
                                <TableCell>Due Date</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Operations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoiceData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.number}
                                    </TableCell>
                                    <TableCell>{row.matter ? row.matter[0].number : ""}</TableCell>
                                    <TableCell>{this.extractClientName(row)}</TableCell>
                                    <TableCell>{this.extractAttorney(row)}</TableCell>
                                    <TableCell>{this.countTotalFee(row)}</TableCell>
                                    <TableCell>{timeFormat(row.date)}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button size="small" variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            {/* <Button size="small" variant="outlined" color="primary" onClick={e => this.handleEmail(e, row)}>Email</Button> */}
                                            {editBtnView(row)}
                                            {delBtnView(row)}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {invoiceData.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={13} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={13}
                                    count={total_items}
                                    page={invoiceData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Drawer anchor="right" open={this.state.stateRight} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                        ></SideList>
                    </div>
                </Drawer>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this invoice?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        const caseNumber = localStorage.getItem('case_num');
        const case_id = localStorage.getItem('case_id');
        this.setState({
            caseNumber,
            case_id
        }, () => {
            this.getInvoiceData();
        })
    }
    getInvoiceData() {
        const {
            client_name,
            case_number,
            matter_number,
            page_index,
            page_size,
        } = this.state;
        let params = {
            client_name: client_name ? client_name : null,
            case_number: case_number ? case_number : null,
            matter_number: matter_number ? matter_number : null,
            page_index,
            page_size
        }
        this.getInvoices(params);
    }
    handleCreateInvoice() {
        this.setState(() => ({
            dialogData: null
        }))
        this.props.history.push({ pathname: '/main/invoicecreate' });
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        // this.openDialog("VIEW CASE", VIEW);
        this.toInvoiceInfo(obj, VIEW);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            dialogData: obj,
        }))
        this.toInvoiceInfo(obj, EDIT);
    }
    handleEmail(e, obj) {
        this.setState(() => ({
            dialogData: obj,
        }))
        this.openDialog("VIEW CASE", VIEW);
    }
    handleDel(e, obj) {
        this.crtInvoiceId = obj.id;
        this.setState(() => ({
            showAlert: true
        }));
    }
    toInvoiceInfo(obj, state) {
        this.props.history.push({ pathname: '/main/invoicenormalinfo' });
        localStorage.setItem('invoiceObj', JSON.stringify(obj));
        localStorage.setItem('invoiceState', state);
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        this.delInvoice(this.crtInvoiceId);
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleCloseDialog() {
        this.getInvoiceData();
        this.closeDialog();
    }
    handleSearch(e, name) {
        const value = e.target.value;
        if (name === "number") {
            this.setState({
                case_number: value,
                matter_number: value,
                page_index: 1
            }, () => {
                this.getInvoiceData();
            })
        } else if (name === "client_name") {
            this.setState({
                client_name: value,
                page_index: 1
            }, () => {
                this.getInvoiceData();
            })
        }
    }
    handleApply(obj) {
        console.log(obj)
        this.setState({
            page_index: 1,
            drawerOpen: false,
        }, () => {
            this.getInvoiceData();
        })
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getInvoiceData();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getInvoiceData();
        });
    }
    handleDrawer(e, open) {
        this.setState(() => ({
            stateRight: open
        }));
    };
    handleCancel() {
        this.closeDialog();
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
        }));
    }
    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }
    extractAttorney(row) {
        if (row.matter) {
            const clientObj = row.matter[0].case.client;
            const handlers = clientObj.handler;
            let handlerObj = {};
            for (const obj of handlers) {
                if (obj.is_origin_attorney) {
                    handlerObj = obj;
                }
            }
            if (handlerObj) {
                return handlerObj.user.first_name + " " + handlerObj.user.last_name;
            }
        }
        return "--";
    }
    extractClientName(row) {
        if (row.matter) {
            const clientObj = row.matter[0].case.client;
            if (clientObj.corporation) {
                const oObj = clientObj.corporation;
                return oObj.name;
            } else if (clientObj.individual) {
                const iObj = clientObj.individual;
                return iObj.first_name + " " + iObj.last_name;
            }
        }
        return "--";
    }
    countTotalFee(row) {
        const total_service_fee = row.total_service_fee ? row.total_service_fee : 0;
        const total_prepayment = row.total_prepayment ? row.total_prepayment : 0;
        const total_deposite = row.total_deposite ? row.total_deposite : 0;
        const total_payment = row.total_payment ? row.total_payment : 0;
        const total_discount = row.total_discount ? row.total_discount : 0;
        // const total_expenditure = row.total_expenditure ? row.total_expenditure : 0;
        const totalDueFee = total_service_fee -
            total_prepayment -
            total_deposite -
            total_payment -
            total_discount;
        if (totalDueFee < 0) {
            return "(" + Math.abs(totalDueFee) + ")";
        }
        return totalDueFee;
    }
    //---------------request---------------
    getInvoices(params) {
        instance.get(BASE_URL + roleStr() + '/billing/invoices', { params }).then((res) => {
            const invoiceData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(invoiceData)
            this.setState(() => ({
                invoiceData,
                page_size,
                total_items
            }));
        }).catch((err) => {
            console.log(err)
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }
    delInvoice(invoice_id) {
        instance.delete(BASE_URL + roleStr() + '/billing/invoices/' + invoice_id).then((res) => {
            console.log(res)
            this.crtCaseId = "";
            this.getInvoiceData();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}


export default withRouter(CaseInvoice);